export default __webpack_public_path__ + "static/media/UserInfoIcon.fda8431e.svg";